/**
 * Follow missing dependencies until a figure is missing for a reason of its
 * own. A figure with none behind it is its own root. A cycle ends at the
 * figure asked about. Keys in the order first reached.
 */
export const rootFigures = (
  key: string,
  missingDeps: (key: string) => string[],
): string[] => {
  const roots: string[] = [];
  const seen = new Set<string>();
  const walk = (at: string) => {
    if (seen.has(at)) return;
    seen.add(at);
    const deps = missingDeps(at).filter((dep) => dep !== at);
    if (!deps.length) roots.push(at);
    else deps.forEach(walk);
  };
  walk(key);
  return roots.length ? roots : [key];
};
